import styles from './SuccessContent.module.scss';
import { Button, Icon, Text } from 'components';

type Props = {
  handleConfirm(): void;
  onClose(): void;
};

export const SuccessContent = ({ handleConfirm, onClose }: Props) => {
  return (
    <div>
      <div className={styles.newPatientCaseCreatedMessage}>
        <Icon name="Tick" />
        <Text className={styles.successTitle} type="body-big">
          New patient successfully created
        </Text>
        <div className={styles.descriptionText}>
          <Text type="body2" className={styles.helpMessage}>
            Now you can see new created patient on the dashboard and in patients list
          </Text>
        </div>
      </div>
      <div className={styles.buttonRow}>
        <Button isLink onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleConfirm}>Go to patient</Button>
      </div>
    </div>
  );
};
